import { applyTraitChanges } from "utils/traitsUtils";

const useApplyTraitChanges = (
  initialTraits: number[],
  newTraits: number[]
): number[] => applyTraitChanges(initialTraits, newTraits);

export default useApplyTraitChanges;
